import React from 'react'
import { Route } from 'react-router-dom'

import HomeView from "./index";

const HomeViewRoutes = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            <HomeView {...rest}>
                <Component {...props} />
            </HomeView>
        )} />
    )
}

export default HomeViewRoutes
